import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  title: 'DESCARGA',
  desc: 'Recibes el manual digital directamente en tu WhatsApp o Email.'
}, {
  num: '2',
  title: 'LEE EN 15 MINUTOS',
  desc: 'Está diseñado para madres sin tiempo. Ve directo a la acción.'
}, {
  num: '3',
  title: 'APLICA',
  desc: 'La próxima vez que veas la señal de crisis, activa el protocolo y mira cómo el ciclo de 90 segundos hace el trabajo por ti.'
}];
export function HowItWorks() {
  return <section className="py-20 bg-brand-cream px-6" data-id="element-129">
      <div className="max-w-5xl mx-auto" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-131">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-132">Cómo funciona</h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-10" data-id="element-133">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center relative" data-id="element-134">
              <div className="text-7xl font-serif text-brand-sage/20 font-bold mb-4 absolute -top-8 left-1/2 -translate-x-1/2 -z-10" data-id="element-135">
                {step.num}
              </div>
              <h3 className="font-bold text-xl mb-4 text-brand-navy tracking-wide" data-id="element-136">
                {step.title}
              </h3>
              <p className="text-brand-navy/80 leading-relaxed" data-id="element-137">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}